module.exports = __webpack_public_path__ + "statics/img/FeaturedCases-3.d6609292.png";